//shared/components/chat/ChatContainer.js
import { Box } from "@mui/material";
import ChatSidebar from "./ChatSidebar";
import ChatWindow from "./ChatWindow";
import { useChatContext } from "../../context/chat-context";
import { useContext } from "react";
import { AuthContext } from "../../context/auth-context";

const ChatContainer = ({ embedded = false }) => {
  const auth = useContext(AuthContext);
  const chat = useChatContext();

  return (
    <Box
      sx={{
        display: "flex",
        height: embedded ? "100%" : "calc(100vh - 64px)",
      }}
    >
      <ChatSidebar
        conversations={chat.conversations}
        selectedId={chat.selectedConversation?.id}
        onSelect={chat.selectConversation}
        loading={chat.loadingUsers}
      />

      <ChatWindow
        conversation={chat.selectedConversation}
        messages={chat.messages}
        loading={chat.loading}
        messagesEndRef={chat.messagesEndRef}
        onSendMessage={chat.sendMessage}
        currentUserId={auth.userId}
        isAI={chat.isLlamaChat}
        onClearHistory={chat.clearLlamaHistory}
        isTyping={chat.isLlamaChat && chat.llamaLoading}
      />
    </Box>
  );
};

export default ChatContainer;
